import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import './App.css';
import './CircleGlide.css';
import HowItWorksSteps from './HowItWorksSteps';
import BuiltForCityDogs from './BuiltForCityDogs';
import AppStoreButton from './AppStoreButton';
import AppPage from './AppPage';
import PrivacyPolicy from './PrivacyPolicy';
import TermsOfUse from './TermsOfUse';
import Contact from './Contact';
import SEOContent from './SEOContent';
import BoneBackgroundPage from './BoneBackgroundPage';
import SharePost from './SharePost';
import ShareUser from './ShareUser';
import { FaInstagram, FaTiktok } from 'react-icons/fa';
import { IoIosMail } from 'react-icons/io';

function HomePage() {

  return (
    <Router>
      <Routes>
        <Route path="/app" element={<AppPage />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfUse />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/app-privacy" element={<PrivacyPolicy />} />
        <Route path="/app-terms" element={<TermsOfUse />} />
        <Route path="/dev/bonebg" element={<BoneBackgroundPage />} />
        <Route path="/posts/:postId" element={<SharePost />} />
        <Route path="/users/:userId" element={<ShareUser />} />
        <Route path="/" element={<HomePageMeat />} />
      </Routes>
      <footer className="footer">
        <div className="container">
          <div className="footer-links">
            <Link to="/privacy">App Privacy Policy</Link>
            <Link to="/terms">Terms of Use</Link>
            <Link to="/contact">Contact Us</Link>
          </div>
          <div className="footer-icons" style={{ display: 'flex', justifyContent: 'center', gap: '24px', marginTop: '18px', fontSize: '2rem' }}>
            <a href="https://instagram.com/yuppy.nyc" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><FaInstagram /></a>
            <a href="mailto:yuppy@yuppy.nyc" aria-label="Email"><IoIosMail /></a>
            <a href="https://tiktok.com/@yuppynyc" target="_blank" rel="noopener noreferrer" aria-label="TikTok"><FaTiktok /></a>
          </div>
        </div>
      </footer>
    </Router>
  );
}

function HomePageMeat() {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  
  const heroImages = [
    require('./assets/images/ios-feed.png'),
    require('./assets/images/ios-leaderboard.png'),
    require('./assets/images/ios-map-review-light.png'),
    require('./assets/images/ios-new-profile-light.png'),
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % heroImages.length);
    }, 5000); // Change image every 5 seconds

    return () => clearInterval(interval);
  }, [heroImages.length]);

  return (
    <div className="yuppy-app">
      <SEOContent />
      <header className="header">
        <div className={`container header-container ${mobileMenuOpen ? 'menu-open' : ''}`}>
          <div className="logo">
            <img src={require('./assets/images/fixed-logo-1024.png')} alt="Yuppy NYC dog social app logo - Manhattan Brooklyn Queens Bronx Staten Island dog community" className="logo-img" />
            yuppy
          </div>
          <nav className={`navigation`}>
            <a href="#home" className="nav-link">HOME</a>
            <span className="nav-separator">/</span>
            <Link to="/app" className="nav-link">DOWNLOAD YUPPY</Link>
          </nav>
          <button 
            className="mobile-menu-toggle"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
          >
            <span className={`hamburger-line ${mobileMenuOpen ? 'open' : ''}`}></span>
            <span className={`hamburger-line ${mobileMenuOpen ? 'open' : ''}`}></span>
            <span className={`hamburger-line ${mobileMenuOpen ? 'open' : ''}`}></span>
          </button>
        </div>
        {mobileMenuOpen && (
          <div className="mobile-menu-overlay" onClick={() => setMobileMenuOpen(false)}></div>
        )}
        <nav className={`mobile-navigation ${mobileMenuOpen ? 'open' : ''}`}>
          <button 
            className="mobile-menu-close"
            onClick={() => setMobileMenuOpen(false)}
            aria-label="Close menu"
          >
            ×
          </button>
          <a href="#home" className="mobile-nav-link" onClick={() => setMobileMenuOpen(false)}>Home</a>
          <Link to="/app" className="mobile-nav-link" onClick={() => setMobileMenuOpen(false)}>Download Yuppy</Link>
        </nav>
      </header>

      <section className="hero">
        <div className="container">
          <div className="hero-grid">
            <div className="hero-content">
              <h1>The daily dog social app where you post, share, and compete with the rest of NYC.</h1>
              <p className="hero-download-text">Download now on the App Store</p>
              <div className="app-store-buttons">
                <AppStoreButton />
              </div>
            </div>
            <div className="hero-image">
              {heroImages.map((image, index) => (
                <img 
                  key={index}
                  src={image} 
                  alt={`Yuppy NYC dog app showing ${index === 0 ? 'daily photo challenges' : index === 1 ? 'leaderboard and competition' : index === 2 ? 'map and reviews' : 'profile and connections'}`}
                  className={`hero-carousel-image ${index === currentImageIndex ? 'active' : ''} ${index === 0 ? 'hero-feed-image' : ''}`}
                />
              ))}
            </div>
          </div>
        </div>
      </section>

      <section id="features" className="features">
        <div className="container">
          <h2 className="section-title">Welcome to yuppy</h2>
          <HowItWorksSteps />
        </div>
      </section>
      
      <section id="join" className="join-section">
        <div className="container">
          <AppStoreButton />
        </div>
      </section>
    </div>
  );
}

export default HomePage;